module.exports = __webpack_public_path__ + "static/media/jet-is-wrong.888eaac5.mp3";